import React, { useState, useEffect, useRef } from "react";
import "./DestinationsPage.css";
import VideoPage from "../LandingFolder/VideoSection";
import BlackEnvelopeIcon from "../../assets/blackEnvelopeIcon.png"
import FbBlackIcon from "../../assets/fbBlackIcon.png"
import BlackWhatsappIcon from "../../assets/blackWhatsappIcon.png"
import { useNavigate } from 'react-router-dom';
import MostPopular from "../LandingFolder/MostPopular";
import GallerySection from "./GallerySection";
import HeadlineRatingStar from "../../assets/headlineRatingStar.png"
import { useLocation } from 'react-router-dom';
import { BASE_URL, get } from "../../services/Calls";
import Loader from "../../GeneralComponents/Loader";
import Header from "../../GeneralComponents/Header";
import Footer from "../../GeneralComponents/Footer";
import { Helmet } from "react-helmet";
const DestinationsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [countryData, setCountryData]: any = useState({})
    const [loader, setLoader] = useState(false)
    
    const [mobileView, setMobileView] = useState(window.innerWidth <= 768);


    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [metaURL, setMetaURL] = useState("");
    const [heading, setHeading] = useState("");
    const [subHeading, setSubHeading] = useState("");

 useEffect(() => {
    
        const encodedString = window.location.pathname;
        let countryInUrl1 = decodeURIComponent(encodedString.replace('/', ''));
        let countryInUrl = decodeURIComponent(countryInUrl1.split('-')[0]);
        if(countryInUrl=="Greece")
        {
            setMetaTitle("off-road Tours in Greece | INDIE4X4 Adventures");
            setMetaDescription("Explore off-road Greece with the INDIE4X4 app. Discover remote trails, wild nature and local experiences - all with GPS guidance, live support and full independence.");
            setHeading("Self-Guided, self-drive Off Road Adventures in Greece");
            setMetaURL("https://indie4x4.com/greece-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Montenegro")
        {
            setMetaTitle("off-road Tours in Montenegro | INDIE4X4 Adventures");
            setMetaDescription("Discover Montenegro’s rugged beauty with INDIE4X4. Drive remote trails, alpine passes and forgotten villages with full GPS navigation and absolute freedom.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Montenegro");
            setMetaURL("https://indie4x4.com/montenegro-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Albania")
        {
            setMetaTitle("off-road Tours in Albania | INDIE4X4 Adventures");
            setMetaDescription("Venture deep into Albania with INDIE4X4 – drive forgotten trails, explore mountain villages, and immerse yourself in Balkan wilderness. GPS guided, self-paced.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Albania");
            setMetaURL("https://indie4x4.com/albania-off-road-tours");
            setSubHeading("4X4 Self Drive Tours in Albania – Europe’s Wild Frontier Off Road");
        }
        else if(countryInUrl=="Bulgaria")
        {
            setMetaTitle("off-road in Bulgaria | INDIE4X4 Adventures");
            setMetaDescription("Explore the untamed side of Bulgaria on a 4x4 adventure with INDIE4X4. GPS-guided routes take you through mountains, monasteries and off-road magic.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Bulgaria");
            setMetaURL("https://indie4x4.com/bulgaria-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Georgia")
        {
            setMetaTitle("off-road Tours in Georgia | INDIE4X4 Adventures");
            setMetaDescription("Drive into the heart of the Caucasus with INDIE4X4. Explore Georgia's wild mountains, ancient churches and warm villages—all with GPS freedom.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Georgia");
            setMetaURL("https://indie4x4.com/georgia-off-road-tours");
            setSubHeading("4X4 Self Drive Tours in Georgia – Journey into the Caucasus");
        }
        else if(countryInUrl=="Iceland")
        {
            setMetaTitle("off-road Tours in Iceland | INDIE4X4 Adventures");
            setMetaDescription("Explore Iceland’s raw wilderness with a 4x4. Drive lava fields, glacier valleys and remote fjords with full GPS navigation and complete freedom.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Iceland");
            setMetaURL("https://indie4x4.com/iceland-off-road-tours");
            setSubHeading("4X4 Self Drive Tours in Iceland – The Land of Fire, Ice and Absolute Freedom");
        }
        else if(countryInUrl=="Costa Rica")
        {
            setMetaTitle("off-road Tours in Costa Rica | INDIE4X4 Adventures");
            setMetaDescription("Drive deep into Costa Rica’s rainforests, volcanoes and coastal jungles with GPS-guided 4x4 routes. Wildlife, waterfalls and pura vida await.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Costa Rica");
            setMetaURL("https://indie4x4.com/Costa%20Rica-off-road-tours");
            setSubHeading("");
            
        }
        else if(countryInUrl=="Spain")
        {
            setMetaTitle("off-road Tours in Spain | INDIE4X4 Adventures");
            setMetaDescription("Discover wild Spain with self-drive 4x4 trails. Explore mountains, deserts and authentic villages with GPS navigation and full independence.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Spain");
            setMetaURL("https://indie4x4.com/Spain-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Portugal")
        {
            setMetaTitle("off-road Tours in Portugal | INDIE4X4 Adventures");
            setMetaDescription("Go beyond the Algarve with self-drive 4x4 routes through wild Portugal. Mountains, river valleys and traditional villages await—fully GPS guided.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Portugal");
            setMetaURL("https://indie4x4.com/Portugal-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Romania")
        {
            setMetaTitle("off-road Tours in Romania | INDIE4X4 Adventures");
            setMetaDescription("Cross Carpathian mountains and Transylvanian forests with GPS-guided 4x4 adventures. Romania is wild, scenic and full of legends.");
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Romania");
            setMetaURL("https://indie4x4.com/Romania-off-road-tours");
            setSubHeading("");
        }
        else if(countryInUrl=="Armenia")
        {
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Armenia");
            setSubHeading("");
            setMetaTitle("off-road Tours in Romania | INDIE4X4 Armenia");
            setMetaURL("https://indie4x4.com/Armenia-off-road-tours");
        }
        else if(countryInUrl=="Israel")
        {
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Israel");
            setSubHeading("");
            setMetaTitle("off-road Tours in Israel | INDIE4X4 Adventures");
            setMetaURL("https://indie4x4.com/Israel-off-road-tours");
        }
        else if(countryInUrl=="Austria")
        {
            setHeading("Self-Guided, Self-Drive Off Road Adventures in Austria");
            setSubHeading("");
            setMetaTitle("off-road Tours in Austria | INDIE4X4 Adventures");
            setMetaURL("https://indie4x4.com/Austria-off-road-tours");
        }
     

 });

    useEffect(() => {


        

        function updateSize() {
            if (window.innerWidth <= 768) setMobileView(true);
            else setMobileView(false);
        }
        window.addEventListener("resize", updateSize);
    }, []);

    useEffect(() => {
        if (location && location.state && location.state.country) {
            setTimeout(() => {
                setCountryData(location.state.country)
            }, 500);
        }
        else {
             
            const encodedString = location.pathname;
            const decodedString = decodeURIComponent(encodedString.replace('/', ''));
            //getCountries(decodedString)
             //console.log('destination page',decodedString.split('-')[0])
            getCountries(decodedString.split('-')[0]); 
        }
        window.scrollTo(0, 0);
    }, []);

    const getCountries = async (countryName: any) => {
        try {
           // console.log('countryName',countryName)
            setLoader(true)
            const response = await get(BASE_URL + '/countries?order=ASC')
            if (response && response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                    if (response[i].name == countryName.replace('/', '')) {
                        setTimeout(() => {
                            setCountryData(response[i])
                            setLoader(false)
                        }, 500);
                    }
                }
            }
        }
        catch (ex) {
            //alert(ex)
            console.log('error', ex)
        }
    }

    return (
        <>
        <Helmet>
        <title>{metaTitle}</title>
        <link rel="canonical" href={metaURL} />
        <meta name="description"  content={metaDescription} />

        <meta property="og:title" content={metaTitle}/>
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={metaURL} />
        <meta property="og:type" content="website" />
       
      </Helmet>
            {countryData && countryData.id && !loader ?
                <div>
                    <Header />
                   {/*  <VideoPage pageFrom={'destination'} countryname={countryData.name} /> */}
                    <VideoPage pageFrom={'destination'} countryname={heading} subHeading={subHeading} />
                    <div className="destinationPathRow" id="destinationPageId">
                        <div className="destinationPaginationDiv">
                            <span className="destinationPaginationHome" onClick={() => { navigate('/') }} >Home</span>
                            <span className="destinationPaginationBorder"></span>
                            <span className="destinationPaginationCountry">{countryData.name}</span>
                        </div>
                        <div className="destinationSocialIconDiv">
                            <a href="https://www.facebook.com/profile.php?id=61576034056586" target="_blank" >
                                <img className="destinationSocialFbIcon" src={FbBlackIcon} /></a>

                            <a href="mailto:info@medraft.co.il"><img className="destinationSocialMailIcon" src={BlackEnvelopeIcon} /></a>
                            <a href="https://wa.me/9720542927253" target="_blank" rel="noopener  noreferrer" > <img className="destinationSocialWhatsAppIcon" src={BlackWhatsappIcon} /></a>
                        </div>
                    </div>


                    <MostPopular pageFrom={'destination'} />
                   {/*  <div className="destinationFollowLine">
                        Follow  # iNDiE {countryData.name}
                    </div>
 */}
                    

                    <div className="destinationDescription">
                        <div className="destinationMainCountryName">
                            {countryData.name}
                        </div>
                        <div className="destinationMainDescription">
                            {/* Driving with iNDiE offers a unique and unforgettable travel experience. Our curated itineraries take you off the beaten path, allowing you to explore hidden gems and immerse yourself in the local culture. With iNDiE, you have the freedom to customize your journey, choosing from a range of activities and destinations. Our expert guides are passionate about providing you with an authentic and enriching adventure. Plus, our commitment to safety and sustainability ensures you can travel with confidence and a clear conscience. Choose iNDiE for a travel experience that's truly one-of-a-kind. */}
                            {countryData.description}
                        </div>
                    </div>
<GallerySection />
                    <div className="destinationRecommendLine">
                        Travelers highly recommend
                    </div>

                    <div className="HeadlineItemDiv" style={mobileView ? { padding: '4vw', gap: '6vw' } : {}}>
                        <div>
                            <img src={HeadlineRatingStar} alt="" />
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <span className="HeadlineItemPersonName">Judi  Y.</span>
                                <span className="HeadlineItemGoogle">Google</span>
                            </div>
                            <div>
                                "In recent years, we've exclusively traveled with Medraft, from the enchanting Lapland to captivating destinations like Greece, Portugal, and the Emirates. Each trip is like stepping into a nature movie, filled with rich experiences, attractions, and everything you need to truly savor the places you visit. They excel in paying attention to even the smallest details."
                            </div>
                        </div>
                        <div>
                            <img src={HeadlineRatingStar} alt="" />
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <span className="HeadlineItemPersonName">Efrat B.</span>
                                <span className="HeadlineItemGoogle">Google</span>
                            </div>
                            <div>
                                "I had an incredible experience with Medraft on a trip to Montenegro. It was fun, professional, diverse, and truly enriching. It even felt life-changing. This was my first organized trip, and it won't be my last. A big thank you to the fantastic Madraft team!"
                            </div>
                        </div>
                        <div>
                            <img src={HeadlineRatingStar} alt="" />
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <span className="HeadlineItemPersonName">Noga G.</span>
                                <span className="HeadlineItemGoogle">Google</span>
                            </div>
                            <div>
                                "For several years, we've chosen Medraft for our journeys to unique and alluring destinations. Their jeeps take us to places buses can't reach, unveiling hidden gems. The company is exceptionally organized, with top-notch guides who cater to every request. We've traveled with them before and will continue to do so. They're true champions!"
                            </div>
                        </div>

                    </div>

                    <div style={{ height: '10.375vw' }}>

                    </div>

                    <Footer />
                </div>
                :
                <Loader />
            }
        </>
    )
}
export default DestinationsPage;
